import { Skeleton } from "@nexus/ui"
import { PersonaGridSkeleton } from "../PersonaGrid/PersonaGrid"

/** Route-level loading skeleton (B11) — shown before the first `GET /personas/list` resolves. */
export function PersonasLoadingState() {
  return (
    <div className="flex flex-col gap-4 p-4">
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-2">
          <Skeleton className="h-6 w-40 rounded-md" />
          <Skeleton className="h-4 w-72 rounded-md" />
        </div>
        <Skeleton className="h-9 w-44 rounded-md" />
      </div>
      <Skeleton className="h-24 w-full rounded-lg" />
      <PersonaGridSkeleton />
    </div>
  )
}
